import React from 'react';
import { motion } from 'framer-motion';
import { LucideIcon } from 'lucide-react';

interface AnimatedIconProps {
  icon: LucideIcon;
  size?: number;
  className?: string;
  color?: string;
  animation?: 'scale' | 'rotate' | 'bounce' | 'pulse' | 'wiggle';
}

const AnimatedIcon: React.FC<AnimatedIconProps> = ({
  icon: Icon,
  size = 24,
  className = '',
  color = 'currentColor',
  animation = 'scale'
}) => {
  const variants = {
    scale: {
      initial: { scale: 1 },
      hover: { scale: 1.2, transition: { type: 'spring', stiffness: 400, damping: 17 } }
    },
    rotate: {
      initial: { rotate: 0 },
      hover: { rotate: 15, transition: { type: 'spring', stiffness: 300, damping: 20 } }
    },
    bounce: {
      initial: { y: 0 },
      hover: { y: -5, transition: { type: 'spring', stiffness: 400, damping: 10 } }
    },
    pulse: {
      initial: { scale: 1 },
      hover: { scale: 1.1, transition: { repeat: Infinity, repeatType: "reverse", duration: 0.3 } }
    },
    wiggle: {
      initial: { rotate: 0 },
      hover: { rotate: [0, -10, 10, -10, 10, 0], transition: { duration: 0.5 } }
    }
  };

  return (
    <motion.div
      initial="initial"
      whileHover="hover"
      className={`inline-flex items-center justify-center ${className}`}
    >
      <motion.div variants={variants[animation] as Record<string, unknown>}>
        <Icon size={size} color={color} />
      </motion.div>
    </motion.div>
  );
};

export default AnimatedIcon;
